export default __webpack_public_path__ + "locales/zh-CN/EmptyTrashDialog.json?hash=03f25103fe427f319bbf5db25d4a6779";